import { Component, OnInit } from "@angular/core";
import { Globals } from "../../_models/globals";
//import {LocalStorageService,SessionStorageService,LocalStorage,SessionStorage,} from "angular-web-storage";
import { ApiIntegration } from "../../_services/api.integration";
import { Router, ActivatedRoute } from "@angular/router";
import {
  HttpClient,
  HttpHeaders,
  HttpErrorResponse,
} from "@angular/common/http";
import { environment } from "../../../environments/environment";
import { OrderHeader } from "../../_models/orderHeader";
import * as _ from "lodash";
import { StockShipmentLine } from "../../_models/stockShipmentLine";
import { OrderLine } from "../../_models/orderLine";
import { AlertService } from "../../_services/alert.service";
import { User } from "../../_models/user";
import { DatePipe } from "@angular/common";

@Component({
  selector: "app-reassign-shipment",
  templateUrl: "./reassign-shipment.component.html",
  styleUrls: ["./reassign-shipment.component.scss"],
  providers: [DatePipe],
})
export class ReassignShipmentComponent implements OnInit {
  order: any = {};
  step: number = 1;
  lBoxLength: number;
  lBoxWidth: number;
  lBoxHeight: number;
  dimensions: any;
  paymentMethod: any;
  paymentType: any;
  boxWeight: number;
  boxWidths: number;
  boxHeights: number;
  boxLengths: number;
  costEstimateList: any = {};
  costEstimation: any;
  reviewOrder: any = {};
  shippingCost: any = [];
  others: boolean = false;
  othersDisplay: string;
  carrierName: string;
  shippedDate: string;
  shipmentCostOther: string;
  AWBNumber: string;
  trackingURL: string;
  carrierNameError: string;
  shippedDateError: string;
  shipmentCostOtherError: string;
  shipmentDateChange: string;

  constructor(
    private alertService: AlertService,
    private datePipe: DatePipe,
    public st: OrderHeader,
    public user: User,
    private http: HttpClient,
    private g: Globals,
    private route: ActivatedRoute,
    private router: Router,
    private api: ApiIntegration
  ) {
    this.viewPage();
  }

  viewPage() {
    this.g.loaderDisplay = "display";
    this.api
      .getOrderDataById(
        this.route.snapshot.params["id"],
        this.user.accountOwnerId,
        "1"
      )
      .subscribe(
        (data: any) => {
          this.g.loaderDisplay = "";
          this.order = data;
          this.reviewOrder = data;
          this.costEstimate();
          if (this.order.paymentMethod === "COD") {
            this.paymentMethod = true;
            this.paymentType = "COD";
          } else {
            this.paymentMethod = false;
            this.paymentType = "Prepaid";
          }
          this.dimensions = data.shipLines;
          for (let d of this.dimensions) {
            this.lBoxHeight =
              this.lBoxHeight > d.boxHeight ? this.lBoxHeight : d.boxHeight;
            this.lBoxWidth =
              this.lBoxWidth > d.boxWidth ? this.lBoxWidth : d.boxWidth;
            this.lBoxLength =
              this.lBoxLength > d.boxLength ? this.lBoxLength : d.boxLength;
          }
        },
        (err) => {
          console.log(err);
          this.g.loaderDisplay = "";
        }
      );
  }

  reviewAndConfirm() {
    this.carrierNameError = '';
    this.shipmentCostOtherError = '';
    this.shippedDateError = '';
    if (this.others == true && !this.carrierName) {
      this.carrierNameError = "please enter carrierName";
    }

    if (this.others == true && !this  .shippedDate) {
      this.shippedDateError = "please enter carrierName";
    }

    if (this.others == true && !this.shipmentCostOther) {
      this.shipmentCostOtherError = "please enter carrierName";
    }

    if (
      this.carrierNameError != "" ||
      this.shippedDateError != "" ||
      this.shipmentCostOtherError != ""
    ) {
      return false;
    }
    this.step = 2;
  }

  selectCost(c) {
    this.others = false;
    this.othersDisplay = "";
    this.shippingCost = c;
    this.othersDisplay = "";
    if (this.shippingCost.carrierCode == "Others") {
      this.others = true;
      this.othersDisplay = "Others";
    }
  }

  costEstimate() {
    this.reviewOrder.shipLines.forEach((sl) => {
      this.boxHeights =
        this.boxHeights > sl.boxHeight ? this.boxHeights : sl.boxHeight;
      this.boxWidths =
        this.boxWidths > sl.boxWidth ? this.boxWidths : sl.boxWidth;
      this.boxLengths =
        this.boxLengths > sl.boxLength ? this.boxLengths : sl.boxLength;
    });
    var header1 = new HttpHeaders();
    this.g.loaderDisplay = "display";
    header1 = header1.append("Content-Type", "application/json");
    header1 = header1.append("Accept", "application/json");
    header1 = header1.append(
      "Authorization",
      "Bearer " + localStorage.getItem("jwt")
    );
    this.http
      .post(
        environment.apiUrl + "api/costEstimationForShiftAggregator",
        {
          accountOwnerContactId: this.order.accountOwnerCustomerId,
          accountOwnerId: this.order.accountOwnerId,
          destPincode: this.order.deliveryAreaPinCode,
          orderType: this.order.orderType,
          length: this.boxLengths,
          breadth: this.boxWidths,
          height: this.boxHeights,
          totalBoxes: this.order.totalBoxes,
          organizationId: this.order.organizationId,
          originPincode: this.order.pickupAreaPinCode,
          weight: this.order.weightOfOrder,
          paymentMethod: this.paymentType,
          orderHeaderId: this.order.orderHeaderId,
        },
        { headers: header1 }
      )
      .subscribe(
        (data) => {
          this.g.loaderDisplay = "";
          if (data["code"] == 200) {
            this.costEstimateList = data;
            this.costEstimation = this.costEstimateList.costEstimateList;
            this.costEstimation.push({
              carrierCode: "Others",
              costEstimates: [
                {
                  id: "",
                  carrierCode: "Others",
                  shippingPreference: "",
                  serviceType: "",
                  totalAmount: null,
                  estimatedDelivery: "",
                  serviceAvailability: "",
                },
              ],
            });

            this.alertService.success(
              "Cost Estimation",
              "Submitted successfully"
            );
          } else if (data["status"] == 500) {
            this.alertService.error(
              "Cost Estimation Failed",
              "to fetch results"
            );
          }  else {
            this.costEstimateList = data;
            this.costEstimation = this.costEstimateList.costEstimateList;
            this.costEstimation.push({
              carrierCode: "Others",
              costEstimates: [
                {
                  id: "",
                  carrierCode: "Others",
                  shippingPreference: "",
                  serviceType: "",
                  totalAmount: null,
                  estimatedDelivery: "",
                  serviceAvailability: "",
                },
              ],
            });
          }

        },
        (err) => {
          this.g.loaderDisplay = "";
          this.alertService.error("Error", err);
        }
      );
  }

  ngOnInit() { }

  submitShipment() {
    this.reviewOrder.shipLines.forEach((sl) => {
      this.boxHeights =
        this.boxHeights > sl.boxHeight ? this.boxHeights : sl.boxHeight;
      this.boxWidths =
        this.boxWidths > sl.boxWidth ? this.boxWidths : sl.boxWidth;
      this.boxLengths =
        this.boxLengths > sl.boxLength ? this.boxLengths : sl.boxLength;
    });
    var header1 = new HttpHeaders();
    this.g.loaderDisplay = "display";
    header1 = header1.append("Content-Type", "application/json");
    header1 = header1.append("Accept", "application/json");
    header1 = header1.append(
      "Authorization",
      "Bearer " + localStorage.getItem("jwt")
    );

    this.http
      .post(
        environment.apiUrl + "api/reAssignShipmentForOrder",
        {
          accountOwnerId: this.order.accountOwnerId,
          orderHeaderId: this.order.orderHeaderId,
          orderStatus: this.order.orderStatus,
          organizationId: this.order.organizationId,
          shipmentPrice: this.shippingCost.carrierCode == "Others"
            ? this.shipmentCostOther
            : this.shippingCost.totalAmount,
          shippingOption: this.shippingCost.carrierCode,
          shippingType: this.shippingCost.serviceType,
          carrierName: this.carrierName,
          shippedDate: this.datePipe.transform(this.shippedDate, "MM/dd/yyyy"),
          trackingURL: this.trackingURL,
          trackingNumber: this.AWBNumber,
        },
        { headers: header1 }
      )
      .subscribe(
        (data) => {
          this.g.loaderDisplay = "";
          if (data["code"] == 200) {
            this.costEstimateList = data;
            this.costEstimation = this.costEstimateList.costEstimateList;
            if (this.user.role == "ACCOUNT_OWNER") {
              this.router.navigate(["/admin/orders"]);
            } else if (this.user.role == "AO_SELLER") {
              this.router.navigate(["/admin/sellerOrdersList"]);
            }
            this.alertService.success(
              "Cost Estimation",
              "Submitted successfully"
            );
          } else if (data["status"] == 500) {
            this.alertService.error(
              "Cost Estimation Failed",
              "to fetch results"
            );
          } else {
            this.alertService.error("Error", data["message"]);
          }
        },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
        }
      );
  }
  carrierNameBlur() {
    this.carrierNameError = "";
    if (!this.carrierName) {
      this.carrierNameError = "please enter carrierName";
    }
  }

  shippedDateBlur() {
    this.shippedDateError = "";
    if (!this.shippedDate) {
      this.shippedDateError = "please select shippedDate";
    }
  }

  shipmentCostOtherBlur() {
    this.shipmentCostOtherError = "";
    if (!this.shipmentCostOther) {
      this.shipmentCostOtherError = "please enter shipmentCost";
    }
  }

}
